<template>

<div class="main list-view">

	<div v-if="!showDetail" class="sub-header">
		<div class="input-with-control">
			<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Search..." @search="getList()" v-focus>
			<div class="button action input-go" @click="getList()"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>
	<div v-else class="sub-header detail-sub-header">
		<div class="detail-title">{{ listDetail.description }}</div>
	</div>

	<div class="filters">

        <div v-if="!showDetail">
		    <div class="button action" @click="addItem()">Create a Product Tag</div>
        </div>
        <div v-if="showDetail">
		    <div class="button action" @click="saveItem()">Save</div>
			<div class="button neutral" @click="searchProducts = true">Add Products</div>
			<div class="divider"></div>
			<div class="button neutral" @click="backToList(true)">Back To List</div>
        </div>
	</div>

    <div v-if="!showDetail" class="list">
	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>
	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list">Code</th>
					<th class="list">Description</th>
					<th class="list">Link Name</th>
					<th class="list center">Hidden</th>
					<th class="list right">Count</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in list" class="clickable-list-item" @click="getItem(item)">
					<td class="list">{{ item.product_tag_code }}</td>
					<td class="list">{{ item.description }}</td>
					<td class="list">{{ item.link_name }}</td>
					<td class="list center"><i v-if="item.internal_use_only" class="fa fa-check" /></td>
					<td class="list right">{{ item.product_count }}</td>
				</tr>
			</tbody>
		</table>
    </div>

    <div v-if="showDetail" class="detail">
		<div class="two-columns" style="margin: 0 0 1em 0;">
			<div>
				<label-required label="Description" :condition="listDetail.description" />
				<input type="text" v-model="listDetail.description" />
				<label>Link Name (will be set from description when saved)</label>
				<input type="text" v-model="listDetail.link_name" readonly />
			</div>
			<div>
				<label-required label="Code (used as a shortcut to this tag)" :condition="listDetail.product_tag_code" />
				<input type="text" v-model="listDetail.product_tag_code" />
				<div class="two-columns" style="padding: 1em 0 0 0;">
					<label class="checkbox">
						<input type="checkbox" v-model="listDetail.internal_use_only" value="1">
						<span><i class="fas fa-check-circle"></i>Hide from Website</span>
					</label>
					<label v-if="listDetail.product_tag_id" class="checkbox">
						<input type="checkbox" v-model="listDetail.inactive" value="1">
						<span><i class="fas fa-check-circle"></i>Deactivate</span>
					</label>
				</div>
			</div>
		</div>

		<h2>Products</h2>
	    <div v-if="productList.length == 0" class="empty-list">
	        The product list is empty
	    </div>
	    <table v-else class="data-list" width="100%" cellpadding="9" cellspacing="0">
			<thead>
				<tr>
					<th class="list" width="40"></th>
					<th class="list">Product</th>
					<th class="list">UPC</th>
					<th class="list right">Available</th>
					<th v-if="!getAdministratorFlag" class="list right">Price</th>
					<th class="list"></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in productList">
					<td class="list center" width="40"><img :src="item.image_src"></td>
					<td class="list">{{ item.description }}</td>
					<td class="list">{{ item.upc }}</td>
					<td class="list right">{{ item.available }}</td>
					<td v-if="!getAdministratorFlag" class="list right">{{ item.price }}</td>
					<td class="list right">
						<div v-if="!getAdministratorFlag" class="button neutral inline spaced" @click="setOverride(item)"><i class='fa fa-dollar-sign' /></div>
						<div class="button neutral inline" @click="removeProduct(item)"><i class='fa fa-trash' /></div>
					</td>
				</tr>
			</tbody>
		</table>

	</div>

	<iframe id="download" src="" style="display: none;"></iframe>

	<message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<price-override-detail v-if="showPriceOverride" :listDetail="priceOverride" @backToList="finishedPriceOverride" />

	<product-search v-if="searchProducts" @assignProduct="assignProduct" @cancel="searchProducts = false" />

	<help-popup :helpLink="{377:'Product Tags'}" :tours="false"></help-popup>


</div>

</template>

<script>
import Loading from '@/components/Loading.vue'
import LabelRequired from '@/components/LabelRequired.vue'
import ProductSearch from '@/components/ProductSearch.vue'
import PriceOverrideDetail from '@/components/PriceOverrideDetail.vue'
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'product-tags',
    components: {
        'loading': Loading,
		'label-required': LabelRequired,
		'product-search': ProductSearch,
		'price-override-detail': PriceOverrideDetail,
		'help-popup': HelpPopup
    },
	data() {
		return {
            loading: false,
			filters: {},
			filterMessage: '',
			list: [],
			paging: {},
			showDetail: false,
			listDetail: {},
            productList: [],
            productPaging: {},
			gettingExport: false,
			exporting: false,
			exportMessage: '',
			searchProducts: false,
			showPriceOverride: false,
			priceOverride: {},
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			saving: false
		}
	},
	created() {
		this.clearFilters()
	},
	methods: {
		clearFilters() {
			this.filters = {
				page: 1,
				search_term: '',
				do_export: 0
			}
			this.getList()
		},
		getList() {
			if (this.loading) { return }
			this.loading = true
			this.apiCall({ destination: 'get_list_product_tags', data: this.filters }).then(obj => {
				this.loading = false
				if (this.filters.do_export) {
					this.filters.do_export = 0
					var outputFile = obj.file_name
					// accommodate live server filecache latency
					setTimeout(() => {
						document.getElementById("download").src = "//" + document.location.hostname + "/download.php?file_name=" + obj.file_name + "&output_file_name=" + outputFile
						this.gettingExport = false
						this.exportMessage = ''
					}, 1500)
				} else {
					this.list = obj.list
					if (obj.paging) {
						this.paging = obj.paging
					}
				}
			}).catch(err => {
				console.log(err)
			})
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		getItem(item) {
			if (this.loading) { return }
            this.showDetail = true
			this.loading = true
			this.apiCall({ destination: 'get_item_product_tag', data: { product_tag_id: item.product_tag_id } }).then(obj => {
				this.loading = false
                this.listDetail = obj.product_tag
				this.productList = obj.product_list
                if (obj.paging) {
                    this.productPaging = obj.paging
                }
			}).catch(err => {
				console.log(err)
			})
		},
		addItem() {
			this.showDetail = true,
			this.listDetail = {}
			this.productList = []
		},
		assignProduct(product) {
			this.searchProducts = false
			let inList = false
			for (var index = 0; index < this.productList.length; index++) {
				if (this.productList[index].product_id == product.product_id) {
					inList = true
				}
			}
			if (!inList) {
				this.productList.push(product)
			}
		},
		setOverride(product) {
			this.priceOverride = product
			this.showPriceOverride = true
		},
		finishedPriceOverride(updateRequired) {
			if (updateRequired) {
				this.getItem(this.listDetail)
			}
			this.showPriceOverride = false
		},
		removeProduct(product) {
			for (var index = 0; index < this.productList.length; index++) {
				if (this.productList[index].product_id == product.product_id) {
					this.productList.splice(index, 1)
				}
			}
		},
		saveItem() {
			if (this.saving) { return }
			if (!this.listDetail.product_tag_code || !this.listDetail.description) {
				this.message = 'Required info is missing.'
				this.messageStatus = 'invalid'
				return
			}
			this.saving = true
			this.message = 'Saving product tag...'
			this.messageStatus = 'waiting'
			this.apiCall({ destination: 'save_item_product_tag', data: { product_tag: this.listDetail, products: this.productList } }).then(obj => {
				this.saving = false
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					this.message = 'Product tag saved!'
					this.messageTimeout = 1500
					// refresh the details
					this.listDetail.product_tag_id = obj.product_tag_id
					this.getItem(this.listDetail)
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		backToList(updateRequired) {
			this.listDetail = {}
			this.searchProducts = false
			this.showDetail = false
			this.saving = false
			this.searching = false
			this.confirmDelete = false
			this.saveMessage = ''
			this.searchMessage = ''
			if (updateRequired) {
				this.getList()
			}
		},
		doExport() {
			if (this.gettingExport) { return false }
			this.gettingExport = true

			//this.exportMessage = 'Generating CSV for ' + this.list.length + ' items...'

			this.saving = true
			this.message = 'Generating CSV for ' + this.list.length + ' items...'
			this.messageStatus = 'waiting'

			this.filters.product_id = ''
			this.filters.do_export = true
			this.getList()
		}
	}
}
</script>
